// extracted by mini-css-extract-plugin
export default {"badge":"Cards_badge__fzbLD","cards":"Cards_cards__qwjTj","img":"Cards_img__V6-fw"};